import Icon from 'veui/components/Icon'
import { IconMove } from 'dls-icons-vue'

Icon.register('move', IconMove)
